import store from "@store";

export default [
	{
		path: "/login",
		name: "login",
		component: () => import("@views/Login.vue"),
		meta: {
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters["loggedIn"]) {
					// Redirect to the home page instead
					if (store.state.userInformation.resetPassword) {
						next({ name: "resetPwd" });
					} else {
						next({ name: "article" });
					}
				} else {
					next();
				}
			},
		},
	},
	{
		path: "/mot-de-passe-oublie",
		name: "forgotPwd",
		component: () => import("@views/ForgotPassword.vue"),
	},
	{
		path: "/reinitialisation-mot-de-passe",
		name: "resetPwd",
		component: () => import("@views/ResetPassword.vue"),
	},
	{
		path: "/404",
		name: "notFound",
		component: () => import("@views/404.vue"),
	},
	{
		path: "/",
		component: () => import("@views/layout/Main.vue"),
		meta: {
			authRequired: true,
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters["loggedIn"]) {
					// Redirect to the home page instead
					if (store.state.userInformation.resetPassword) {
						next({ name: "resetPwd" });
					}
				}
				next();
			},
		},
		children: [
			{
				path: "",
				name: "article",
				component: () => import("@views/page/articlelist/ArticleListPage.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "stocks",
				name: "stocksCalendar",
				component: () => import("@views/home/StockCalendar.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "fournisseurs",
				name: "fournisseur",
				component: () => import("@views/fournisseur/FournisseurList.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "utilisateurs",
				name: "user",
				component: () => import("@views/user/UserList.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "sites",
				name: "site",
				component: () => import("@views/site/SiteList.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "familles",
				name: "famille",
				component: () => import("@views/famille/FamilleList.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "inventaires",
				name: "inventaire",
				component: () =>
					import("@views/page/inventaire/InventaireListPage.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "packs",
				name: "packs",
				component: () => import("@views/page/pack/PackListPage.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "mouvements",
				name: "mouvement",
				component: () => import("@views/page/mouvement/MouvementListPage.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "affectations",
				name: "affectation",
				component: () =>
					import("@views/page/affectation/AffectationListPage.vue"),
				meta: {
					authRequired: true,
				},
			},
			{
				path: "synthese-affectations",
				name: "affectationCalendar",
				component: () =>
					import("@views/page/affectationCalendar/AffectationCalendarPage.vue"),
				meta: {
					authRequired: true,
				},
			},
		],
	},
];
